/* afn-cart-sync.js 11-05: subscriber cart -> af-brevo-sync /c; no afe token = no requests */
(function(){
var W=window,D=document,S,of=W.fetch,tm=0,seq=0,RE=/^\d{1,9}\.[A-Za-z0-9_-]{22}$/,RX=/\/cart\/(add|change|update|clear)(\.js)?([?#]|$)/,
EP='https://af-brevo-sync.martastankevicius.workers.dev/c';
function no(){try{var p=W.Shopify&&W.Shopify.customerPrivacy;return (p&&p.currentVisitorConsent&&p.currentVisitorConsent().marketing==='no');}catch(e){return false;}}
function g(k){try{return JSON.parse(S.getItem(k));}catch(e){return null;}}
function s(k,v){try{S.setItem(k,JSON.stringify(v));}catch(e){}}
function tok(){var o=g('af_e');if(o&&RE.test(o.t)&&Date.now()-o.at<2592e6)return o.t;try{if(o)S.removeItem('af_e');}catch(e){}return null;}
function keep(t){if(typeof t!='string'||!RE.test(t)||no())return false;s('af_e',{t:t,at:Date.now()});return true;}
function send(e,c){
 var L=c.items||[],it=[],i,l,k,pp,o=g('af_cs')||{},b,h=5381,n=c.item_count|0;
 for(i=0;i<L.length&&i<10;i++){
  l=L[i];pp=0;
  for(k in (l.properties||{}))if(k.charAt(0)!='_')pp=1;
  it.push({v:l.variant_id,p:l.product_id,q:l.quantity,pr:l.final_price,op:l.original_price,ti:l.product_title,vt:l.variant_title||'',pp:pp});
 }
 b=JSON.stringify({e:e,t:c.token,n:n,tot:c.total_price|0,cur:c.currency||'EUR',it:it});
 for(i=0;i<b.length;i++)h=(h*33+b.charCodeAt(i))|0;
 if(h===o.h||(!n&&!o.n))return;
 s('af_cs',{h:h,n:n});
 of.call(W,EP,{method:'POST',keepalive:true,credentials:'omit',headers:{'Content-Type':'text/plain'},body:b})['catch'](function(){});
}
function sync(){
 try{
  var e=tok(),n=++seq,r=(W.Shopify&&W.Shopify.routes&&W.Shopify.routes.root)||'/';
  if(!e||no())return;
  of.call(W,r+'cart.js',{cache:'no-store'}).then(function(x){return x.json();})
   .then(function(c){if(n===seq&&c)send(e,c);})['catch'](function(){});
 }catch(x){}
}
function soon(){try{clearTimeout(tm);tm=setTimeout(sync,800);}catch(e){}}
try{S=W.localStorage;}catch(e){}
if(!of||!S||no())return;
try{
 var q=location.search,m=/[?&]afe=([^&#]*)/.exec(q);
 if(m){
  try{keep(decodeURIComponent(m[1]));}catch(e){}
  q=q.slice(1).split('&').filter(function(p){return p&&p.split('=')[0]!='afe';}).join('&');
  history.replaceState(history.state,'',location.pathname+(q?'?'+q:'')+location.hash);
 }
}catch(e){}
try{
 W.fetch=function(r){
  var p=of.apply(this,arguments);
  try{if(RX.test(typeof r=='string'?r:(r&&r.url)||String(r)))p.then(soon,soon);}catch(e){}
  return p;
 };
}catch(e){}
try{
 var X=W.XMLHttpRequest.prototype,xo=X.open,xs=X.send;
 X.open=function(a,u){try{this.__afcs=RX.test(String(u));}catch(e){}return xo.apply(this,arguments);};
 X.send=function(){try{if(this.__afcs)this.addEventListener('loadend',soon);}catch(e){}return xs.apply(this,arguments);};
}catch(e){}
try{
 W.addEventListener('pageshow',function(v){if(v.persisted)sync();});
 D.addEventListener('visibilitychange',function(){if(D.visibilityState=='hidden')sync();});
 W.AFCartSync={identify:function(t){try{if(keep(t)){sync();return true;}}catch(e){}return false;}};
}catch(e){}
sync();
})();
